import { render, staticRenderFns } from "./Dice2.vue?vue&type=template&id=40ad6609&scoped=true&"
import script from "./Dice2.vue?vue&type=script&lang=js&"
export * from "./Dice2.vue?vue&type=script&lang=js&"
import style0 from "./Dice2.vue?vue&type=style&index=0&id=40ad6609&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ad6609",
  null
  
)

export default component.exports